import Game from "./Game";

export default class SwipeRotation {
  constructor(scene) {
    this.scene = scene;
    this.numFrames = Game.frames;
    this.isDragging = false;
    this.startX = 0;
    this.dragThreshold = Game.dragThreshold;
    this.enabled = false;
  }

  enable() {
    this.enabled = true;
    this.scene.input.on("pointerdown", this.startDrag, this);
    this.scene.input.on("pointermove", this.onDrag, this);
    this.scene.input.on("pointerup", this.endDrag, this);
  }

  disable() {
    this.enabled = false;
    this.scene.input.off("pointerdown", this.startDrag, this);
    this.scene.input.off("pointermove", this.onDrag, this);
    this.scene.input.off("pointerup", this.endDrag, this);
  }

  startDrag(pointer) {
    this.isDragging = true;
    this.startX = pointer.x;
  }

  onDrag(pointer) {
    if (!this.isDragging) return;

    // Calcola lo spostamento del drag
    const deltaX = pointer.x - this.startX;

    // Se lo spostamento supera una certa soglia cambia immagine
    if (Math.abs(deltaX) > this.dragThreshold) {
      // +1 per destra, -1 per sinistra
      const frameChange = Math.sign(deltaX);
      this.showFrame(frameChange);
      // Aggiorna la posizione di partenza per il prossimo drag
      this.startX = pointer.x;
    }
  }

  endDrag() {
    this.isDragging = false;
  }

  showFrame(frameChange) {
    // Aggiorna l'immagine corrente in base al trascinamento
    this.currentFrame = (this.scene.currentFrame + frameChange + this.numFrames) % this.numFrames;
    this.scene.setFrame(this.currentFrame);
  }
}
